(function homeAquariumGuideController(root) {
  const videoSelector = '.home-aquarium-guide__video, .home-aquarium-guide__style-video';
  const reducedMotionQuery = root.matchMedia
    ? root.matchMedia('(prefers-reduced-motion: reduce)')
    : null;
  let syncFrame = 0;

  function revealVideo(video) {
    if (video.classList.contains('is-video-ready')) {
      return;
    }

    if (typeof video.requestVideoFrameCallback === 'function') {
      video.requestVideoFrameCallback(() => {
        video.classList.add('is-video-ready');
      });
      return;
    }

    root.requestAnimationFrame(() => {
      video.classList.add('is-video-ready');
    });
  }

  function isVisible(element) {
    if (!element || !element.isConnected) {
      return false;
    }

    if (element.hasAttribute('hidden')) {
      return false;
    }

    const style = root.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }

    return element.getClientRects().length > 0;
  }

  function isInViewport(element) {
    if (!element || !element.isConnected) {
      return false;
    }

    const bounds = element.getBoundingClientRect();
    return bounds.bottom > 0
      && bounds.right > 0
      && bounds.top < root.innerHeight
      && bounds.left < root.innerWidth;
  }

  function prepareVideo(video) {
    if (video.dataset.aquariumGuideVideoReady === 'true') {
      return;
    }

    video.dataset.aquariumGuideVideoReady = 'true';
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    video.addEventListener('playing', () => revealVideo(video), { once: true });
    video.addEventListener('timeupdate', () => revealVideo(video), { once: true });
    video.addEventListener('error', () => {
      video.classList.remove('is-video-ready');
    });
  }

  function syncVideos(scope) {
    const container = scope && scope.querySelectorAll ? scope : root.document;
    const reduceMotion = Boolean(reducedMotionQuery && reducedMotionQuery.matches);

    container.querySelectorAll(videoSelector).forEach((video) => {
      prepareVideo(video);

      const slide = video.closest('.home-aquarium-guide__media-slide, .home-aquarium-guide__panel');
      const section = video.closest('.home-aquarium-guide');
      const shouldPlay = !reduceMotion
        && (!slide || isVisible(slide))
        && isInViewport(section || video);

      if (shouldPlay) {
        if (typeof video.play === 'function') {
          const playRequest = video.play();
          if (playRequest && typeof playRequest.catch === 'function') {
            playRequest.catch(() => {});
          }
        }
        return;
      }

      if (typeof video.pause === 'function') {
        video.pause();
      }
    });
  }

  function scheduleSync() {
    if (syncFrame) {
      return;
    }

    syncFrame = root.requestAnimationFrame(() => {
      syncFrame = 0;
      syncVideos(root.document);
    });
  }

  function observeSection(section) {
    if (!section || section.dataset.aquariumGuideObserved === 'true') {
      return;
    }

    section.dataset.aquariumGuideObserved = 'true';
    syncVideos(section);

    const observer = new MutationObserver(scheduleSync);

    observer.observe(section, {
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden'],
      childList: false,
      subtree: true,
    });

    section.addEventListener('transitionend', scheduleSync);
  }

  function init(scope) {
    const rootNode = scope && scope.querySelectorAll ? scope : root.document;
    rootNode.querySelectorAll('.home-aquarium-guide').forEach(observeSection);
    syncVideos(rootNode);
  }

  if (root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', () => init(root.document), { once: true });
  } else {
    init(root.document);
  }

  root.document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  root.document.addEventListener('visibilitychange', scheduleSync);
  root.addEventListener('resize', scheduleSync);
  root.addEventListener('scroll', scheduleSync, { passive: true });

  if (reducedMotionQuery) {
    if (typeof reducedMotionQuery.addEventListener === 'function') {
      reducedMotionQuery.addEventListener('change', scheduleSync);
    } else if (typeof reducedMotionQuery.addListener === 'function') {
      reducedMotionQuery.addListener(scheduleSync);
    }
  }
})(window);
